var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39828 10.2844C6.39828 9.85555 6.54711 9.45972 6.79819 9.14133H1.7994C0.805617 9.14133 0 9.90859 0 10.8552V11.2953C0 11.9757 0.254851 12.6338 0.718746 13.1511C1.972 14.549 3.88113 15.2388 6.39828 15.2388H6.43845C6.41213 15.1154 6.39828 14.9877 6.39828 14.8569V14.0957C4.20724 14.0957 2.63427 13.5273 1.63145 12.4088C1.35312 12.0984 1.2002 11.7036 1.2002 11.2953V10.8552C1.2002 10.54 1.46847 10.2844 1.7994 10.2844H6.39828ZM6.39828 0C8.60778 0 10.399 1.70596 10.399 3.81037C10.399 5.91479 8.60778 7.62076 6.39828 7.62076C4.18874 7.62076 2.39757 5.91479 2.39757 3.81037C2.39757 1.70596 4.18874 0 6.39828 0ZM6.39828 1.14311C4.85159 1.14311 3.59777 2.33729 3.59777 3.81037C3.59777 5.28346 4.85159 6.47765 6.39828 6.47765C7.94495 6.47765 9.19876 5.28346 9.19876 3.81037C9.19876 2.33729 7.94495 1.14311 6.39828 1.14311ZM11.6071 12.896L7.21362 10.4551C7.32124 9.71288 7.98991 9.14133 8.79877 9.14133H14.3997C15.2757 9.14133 15.9873 9.81173 15.9998 10.6431L11.6071 12.896ZM11.7889 13.6683L16 11.5086V14.4759C16 15.3176 15.2836 16 14.3997 16H8.79877C7.91494 16 7.1985 15.3176 7.1985 14.4759V11.3289L11.3977 13.6619C11.518 13.7288 11.6662 13.7312 11.7889 13.6683Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitor);
export default __webpack_public_path__ + "static/media/visitor.b3ae42826d1cf256c1add4ba90cfe412.svg";
export { ForwardRef as ReactComponent };